import DetailsGridColumns from '@components/shared/DetailsGridColumns';
import { PAYOUT_METHOD } from '@constant/steps';
import { TransferDetailsContext } from '@context/TransferDetailsContext';
import { Box, Divider, Grid, Link, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	subtitle: {
		color: theme.text.tertiary,
		fontWeight: '700',
		fontSize: '0.75rem'
	},
	content: {
		color: theme.text.primary,
		fontWeight: '700',
		fontSize: '0.875rem'
	},
	contentLight: {
		color: theme.text.primary,
		fontWeight: '600',
		fontSize: '0.875rem'
	}
}));

const getCashPickupInfo = (details, t, classes) => {
	return [
		...(details?.transaction?.cashPickup?.agentName
			? [
					{
						subTitle: t('PICKUP_AGENT'),
						content: details.transaction.cashPickup.agentName,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.contentLight
					}
				]
			: []),
		...(details?.transaction?.cashPickup?.locationUrl
			? [
					{
						subTitle: t('LOCATION'),
						content: <ViewLocationInfo link={details.transaction.cashPickup.locationUrl} />,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.content
					}
				]
			: [])
	];
};

const ViewLocationInfo = ({ link }) => {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<Typography variant="h6" sx={{ fontWeight: '700', color: theme.text.primary, mr: 0.5 }}>
					{t('AT_ANY_BRANCHES')}
				</Typography>
				<Link href={link} target="_blank" rel="noopener noreferrer" sx={{ fontWeight: '600', cursor: 'pointer' }} color="secondary">
					{t('MORE_INFO')}
				</Link>
			</Box>
		</>
	);
};

const CashPickupInformation = () => {
	const theme = useTheme();
	const { t } = useTranslation();
	const { classes } = useStyles();
	const { details }: any = useContext(TransferDetailsContext);

	return (
		<>
			{PAYOUT_METHOD?.[details?.transaction?.payoutMethod.toUpperCase()] === PAYOUT_METHOD.CASH_PICKUP && (
				<Grid container direction="column">
					<Grid item>
						<Typography variant="h6" pb="5px" color={theme.text.secondary} sx={{ fontSize: '0.75rem' }}>
							{t('CASH_PICKUP_INFORMATION')}
						</Typography>
					</Grid>
					<Divider />
					<Grid item pt="16px" pb="32px">
						<Grid container direction="column">
							<DetailsGridColumns data={getCashPickupInfo(details, t, classes)} />
						</Grid>
					</Grid>
				</Grid>
			)}
		</>
	);
};

export default CashPickupInformation;
